import React, { useEffect, useState } from "react";
import { useAxios } from "../../../common_nextgen/axios/AxiosHelper";
import useCustomNavigate from "../../../common_nextgen/common_components/Navigation/NextGenNavigation";
import getBackendUrl from "../../../environment/BackendService";
import { fetchDropdownValues } from "../../../common_nextgen/common_components/dropdown/DropdownHelper";
import { useLocation } from "react-router-dom";
import { ROUTE_PATHS } from "../../../common_nextgen/utils/Constants";
import { useToast } from "../../../common_nextgen/hooks/ToastContext";
import { downloadCSV } from "../../../common_nextgen/utils/UtilFunctions";


const useOutofPocketPatientPaySchedule = () => {
  const {
    OUT_OF_POCKET_MAX_SCHEDULE_STEPS,
    ADD_OUT_OF_POCKET_PATIENT_PAY_SCHEDULE,
    EDIT_OUT_OF_POCKET_PATIENT_PAY_SCHEDULE,
    DISPLAY_OUT_OF_POCKET_PATIENT_PAY_SCHEDULE,
    OUT_OF_POCKET_MAX_SCHEDULE,
  } = ROUTE_PATHS;
  const location = useLocation();
  const [data, setData] = useState([]);
  const { axios_helper_no_header } = useAxios();

  const { state: stateVal } = location;
  let [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);
  //console.log("current state in form", currentState, previousState);
  let {
    selectedSteps = [],
    previousScreen = OUT_OF_POCKET_MAX_SCHEDULE,
    currentIndex: initialIndex = 0,
    description,
    scheduleName,
  } = currentState;

  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowData, setRowData] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const navigateToPage = useCustomNavigate();
  const [dropdownValues, setDropdownValues] = useState({});
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("no");
  const [isInactiveConfirmationModalOpen, setIsInactiveConfirmationModalOpen] =
    useState(false);
  const [inactiveSelectedOption, setInactiveSelectedOption] = useState("no");
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const toast = useToast();
  const screen_title = "OOP Patient Pay Schedules";
  const screenNumber = "RCOPP001";

  const [paramsData, setParamsData] = useState({
    opcScheduleName: scheduleName,
    description: description,
    opdStepNumber: selectedSteps[initialIndex].opdStepNumber,
    oppStatus: "A",
  });

  /* Search form fields that needs to be shown for filtering */
  const formFields = [
    {
      fieldLabel: "Schedule",
      name: "opcScheduleName",
      label: "Schedule",
      type: "text",
      fieldNature: "readOnly",
      value: "",
      maxLength: 10,
    },
    {
      fieldLabel: "Description",
      name: "description",
      label: "Description",
      type: "text",
      fieldNature: "readOnly",
      value: "",
      maxLength: 25,
    },
    {
      fieldLabel: "Step Number",
      name: "opdStepNumber",
      label: "Step Number",
      type: "text",
      fieldNature: "readOnly",
      value: "",
      maxLength: 2,
    },
    {
      fieldLabel: "Hidden Records Indicator*Inactive",
      name: "oppStatus",
      label: "Status",
      type: "dropdown",
      fieldNature: "editable",
      value: "",
      maxLength: 20,
    },
  ];

  /* Dropdown options fields that needs to be fetched with API */
  const dropdownOptions = [
    { field_label: "Hidden Records Indicator", condition: "*Inactive" },
  ];

  const dropdownCondition = {
    dropDowns: dropdownOptions.map((item) => item.field_label + item.condition),
  };

  const leftButtons = [
    {
      button_label: "Back",
      button_handeler: () => {
        if (currentIndex < selectedSteps.length - 1) {
          setCurrentIndex((prevIndex) => prevIndex + 1);
        } else {
          navigateToPage(previousScreen, previousState);
        }
      },
      button_key: "F12",
    },
  ];

  /* ACTION BUTTONS info that needs to be displayed on the page */
  const ctaButtons = [
    {
      button_label: "Add OOP Patient Pay Schedules",
      button_handeler: () => {
        console.log("paramsData-", paramsData);

        navigateToPage(ADD_OUT_OF_POCKET_PATIENT_PAY_SCHEDULE, [
          ...previousState,
          { ...currentState, currentIndex },
          {
            previousScreen: location.pathname,
            opcScheduleName: paramsData.opcScheduleName,
            opdStepNumber: paramsData.opdStepNumber,
          },
        ]);
      },
      button_key: "F6",
    },
    {
      button_label: "Export as CSV",
      button_handeler: () => {
        exportAsCSV();
      },
      button_key: "",
    },
  ];

  /* Gear Icon Menu option CTAs */
  const menuOptions = [
    {
      label: "Edit",
      icon: <span className="material-icons">edit</span>,
      command: () => {
        editValidation();
      },
    },
    {
      label: "Inactivate",
      icon: <span className="material-icons">block</span>,
      command: () => {
        openInactiveConfirmationModal();
      },
    },
    {
      label: "Display",
      icon: <span className="material-icons">visibility</span>,
      command: () => {
        console.log("rowData-", rowData);
        navigateToPage(DISPLAY_OUT_OF_POCKET_PATIENT_PAY_SCHEDULE, [
          ...previousState,
          { ...currentState, currentIndex },
          {
            selectedPatientPaySchedules: selectedRows.length
              ? selectedRows
              : [rowData],
            previousScreen: location.pathname,
            opcScheduleName: paramsData.opcScheduleName,
            opdStepNumber: paramsData.opdStepNumber,
            currentIndex: 0,
          },
        ]);
      },
    },
  ];

  /* Data table column info. */
  const columnDef = [
    {
      header: "From Date",
      field: "oppFromDate",
    },
    {
      header: "Thru Date",
      field: "oppThruDate",
    },
    {
      header: "Pharmacy Patient Pay",
      field: "oppPharmPatpayschedule",
    },
    {
      header: "Client Patient Pay",
      field: "oppClientPatpayschedule",
    },
    {
      header: "Status",
      field: "oppStatus",
    },
  ];

  /* Param Key which used as bridge between various operations on tabluar data */
  const parmKey = "schedule";

  /* Handler that fetches the data */
  const fetchData = async () => {
    console.log("fetch data");
    const page = first / rows;
    try {
      const raw_response = await axios_helper_no_header(
        "GET",
        `api/oppMaxDtlPatPaySch`,
        null,
        {
          page: page,
          size: rows,

          ...paramsData,
        }
      );
      const response = raw_response.responseData;
      const pageResponse = raw_response.responsePaginationDTO;
      if (response.length === 0) {
        setData([]);
        setTotalRecords(0);
        console.log("response.length is ", response.length);
        toast.current.show({
          severity: "info",
          summary: "",
          detail: response.responseStatus.message,
          life: 3000,
        });
      } else {
        setData(response);
        console.log("response", response);
        console.log(pageResponse.totalRecords);
        setTotalRecords(pageResponse.totalRecords); // Assuming the API returns totalRecords
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setTotalRecords(0);
    }
  };

  const fetchDropdownData = async (dataDropdown) => {
    try {
      const response = await fetchDropdownValues(dataDropdown);
      setDropdownValues(response);
    } catch (error) {
      console.error("Error fetching dropdown values:", error);
    }
  };

  useEffect(() => {
    fetchDropdownData(dropdownCondition);
  }, []);

  useEffect(() => {
    fetchData(); // Initial fetch with page 0 and page size 10
  }, [paramsData, rows, currentPage, selectedOption]);
  useEffect(() => {
    setParamsData((paramData) => ({
      ...paramData,
      opdStepNumber: selectedSteps[currentIndex].opdStepNumber,
    }));
  }, [currentIndex]);

  const onPageChange = (event) => {
    console.log("page change", event.first, event);
    setFirst(event.first);
    setCurrentPage(event.page);
    setRows(event.rows);
  };

  const openConfirmationModal = () => {
    setIsConfirmationModalOpen(true);
  };

  const openInactiveConfirmationModal = () => {
    setIsInactiveConfirmationModalOpen(true);
  };

  const closeConfirmationModal = () => {
    console.log(selectedOption);
    setIsConfirmationModalOpen(false);
    setSelectedOption("no");
  };

  const closeInactiveConfirmationModal = () => {
    console.log(inactiveSelectedOption);
    setIsInactiveConfirmationModalOpen(false);
    setInactiveSelectedOption("no");
  };

  const editValidation = () => {
    const params = {
      opcScheduleName: rowData.opcScheduleName,
      opdStepNumber: rowData.opdStepNumber,
      oppSeqNbr: rowData.oppSeqNbr,
    };
    axios_helper_no_header(
      "GET",
      "api/oppMaxDtlPatPaySch/validateBeforeEdit",
      null,
      params
    )
      .then((response) => {
        navigateToPage(EDIT_OUT_OF_POCKET_PATIENT_PAY_SCHEDULE, [
          ...previousState,
          { ...currentState, currentIndex },
          {
            selectedPatientPaySchedules: selectedRows.length
              ? selectedRows
              : [rowData],
            previousScreen: location.pathname,
            opcScheduleName: paramsData.opcScheduleName,
            opdStepNumber: paramsData.opdStepNumber,
            currentIndex: 0,
          },
        ]);
      })
      .catch((error) => {
        console.error("There was an error editing the data!", error);
        const { responseStatus: { displayErrorFields = null, message } = {} } =
          error.data;
        toast.current.show({
          severity: "error",
          summary: "",
          detail: message,
          life: 3000,
        });
      });
  };

  const inActivatePatientPaySchedule = () => {
    if (inactiveSelectedOption === "yes") {
      const params = {
        opcScheduleName: paramsData.opcScheduleName,
        screenNumber: screenNumber,
        opdStepNumber: paramsData.opdStepNumber,
        oppSeqNbr: rowData.oppSeqNbr,
      };
      axios_helper_no_header(
        "PUT",
        "api/oppMaxDtlPatPaySch/inActivate",
        null,
        params
      )
        .then((response) => {
          const updatedItems = data.filter((item) => item[parmKey] !== rowData);
          if (currentPage > 0) {
            setFirst(0);
            setCurrentPage(0);
          } else {
            fetchData();
          }
          toast.current.show({
            severity: "success",
            summary: "",
            detail: response.responseStatus.message,
            life: 3000,
          });
          closeConfirmationModal();
          closeInactiveConfirmationModal();
        })
        .catch((error) => {
          console.error("There was an error inactivating the data!", error);
          const errorMessage =
            error.data?.responseStatus?.message || error.message;
          toast.current.show({
            severity: "error",
            summary: "",
            detail: errorMessage,
            life: 3000,
          });
          closeInactiveConfirmationModal();
        });
    } else {
      closeInactiveConfirmationModal();
    }
  };

  const exportAsCSV = async () => {
    const queryParams = { ...paramsData };
    try {
      const response = await axios_helper_no_header(
        "GET",
        "api/oppMaxDtlPatPaySch/exportcsv",
        null,
        queryParams,
        "blob"
      );
      downloadCSV(response);
    } catch (error) {
      console.error("Error exporting as CSV:", error);
      toast.current.show({
        severity: "error",
        summary: "",
        detail: "Failed to export CSV. Please try again.",
        life: 3000,
      });
    }
  };

  const updateParamData = (data) => {
    setFirst(0);
    setCurrentPage(0);
    setParamsData(data);
  };

  return {
    screenNumber,
    screen_title,
    formFields,
    dropdownValues,
    paramsData,
    updateParamData,
    ctaButtons,
    data,
    parmKey,
    menuOptions,
    columnDef,
    setRowData,
    selectedRows,
    setSelectedRows,
    first,
    rows,
    totalRecords,
    currentPage,
    onPageChange,
    isConfirmationModalOpen,
    closeConfirmationModal,
    setSelectedOption,
    inActivatePatientPaySchedule,
    leftButtons,
    inActivatePatientPaySchedule,
    isInactiveConfirmationModalOpen,
    closeInactiveConfirmationModal,
    setInactiveSelectedOption,
  };
};

export default useOutofPocketPatientPaySchedule;
